import type { TValidRoutes } from '@/tanstackSetup'
import {
  ROUTER_HISTORY_INVALID_ROUTES,
  ROUTER_HISTORY_LOCAL_STORAGE_KEY,
  ROUTER_HISTORY_MAX_LENGTH,
} from '@/utils/router/history/constants'
import { get, set } from '@/utils/storage/localStorage'

/**
 * This history is non-reactive and only useful to properly implement the go back button functionality
 * @returns History of the routes visited while in the App
 */
const getRouterHistory = () => {
  // Reads router history from local storage, removes duplicates just to be sure
  let _routerHistory = (get(ROUTER_HISTORY_LOCAL_STORAGE_KEY) as string[]) ?? []
  _routerHistory = [...new Set(_routerHistory)]

  return _routerHistory
}

/**
 * Only useful as a callback for the router history change subscriber
 * @param pathname Pathname to be added to the local storage that tracks visited routes
 */
export const addToRouterHistory = (pathname: string): void => {
  let _routerHistory = getRouterHistory()

  // If invalid route, do not add it and delete the route before that threw us on invalid route
  // otherwise add the route to the history
  if (ROUTER_HISTORY_INVALID_ROUTES.includes(pathname as TValidRoutes)) {
    _routerHistory.shift()
  } else {
    _routerHistory.unshift(pathname)
  }

  // Remove duplicates, and keep a limited number of paths in history
  _routerHistory = [...new Set(_routerHistory)].splice(0, ROUTER_HISTORY_MAX_LENGTH)

  set(ROUTER_HISTORY_LOCAL_STORAGE_KEY, _routerHistory)
}
